import { Button } from "@/components/ui/button";
import WidgetCard from "./widget-card";
import { CircleArrowRight } from "lucide-react";
import QuickSearch from "../provider-search/quick-search";
import type Widget from "@/model/widget";
import { useNavigate } from "react-router-dom";
import ScreenRouteNames from "@/constants/screen-route-names";

type QuickProviderWidgetProps = {
  className?: string;
  widget: Widget;
};

const QuickProviderWidget: React.FunctionComponent<
  QuickProviderWidgetProps
> = ({ widget }) => {
  const navigate = useNavigate();

  const renderWidget = () => {
    return (
      <div className="flex h-full flex-wrap gap-4">
        <QuickSearch />
      </div>
    );
  };

  const viewAll = () => {
    const targetPath = `/${ScreenRouteNames.PROVIDER_SEARCH_BY_GROUP.path}`;
    navigate(targetPath, {
      replace: false,
    });
  };

  const footerContent = (
    <Button variant="link" className="w-full hover:underline" onClick={viewAll}>
      View All <CircleArrowRight className="ml-1" />
    </Button>
  );

  return (
    <WidgetCard title={widget?.widgetDisplayName} footerContent={footerContent}>
      {renderWidget()}
    </WidgetCard>
  );
};

export default QuickProviderWidget;
